import { useState, useEffect, useCallback } from 'react';

export const useCarouselScroll = (ref, dependency) => {
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = useCallback(() => {
    if (ref.current) {
      const { scrollLeft, scrollWidth, clientWidth } = ref.current;
      setCanScrollLeft(scrollLeft > 20);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 20);
    }
  }, [ref]);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      checkScroll();
      node.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
      const timer = setTimeout(checkScroll, 500);
      return () => {
        node.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
        clearTimeout(timer);
      };
    }
  }, [ref, checkScroll, dependency]);

  const scroll = (dir) => {
    if (ref.current) {
      const amt = ref.current.clientWidth * 0.8;
      ref.current.scrollBy({ left: dir === 'left' ? -amt : amt, behavior: 'smooth' });
    }
  };

  return { canScrollLeft, canScrollRight, scroll, checkScroll };
};